import 'globalCommon/style/common.css';
import 'globalCommon/style/iconfont.css';
import 'globalCommon/style/reset.css';
import 'mCommon/style/common.css';

import { qrCode } from '@umu/page-side-qr-code';
import { getLangSwitchList } from '@umu/umu-lang-switch';
import { gdprCom, ipPrompt } from '@umu/umu-prompt';
import 'babel-polyfill';
import { loadResource, registerBesChannels } from 'globalCommon/gdprResource';
import getSiteHost from 'globalCommon/services/getSiteHost';
import getUserInfo, { IUserInfo } from 'globalCommon/services/getUserInfo';
import { Platform } from '../../../common/utils/index';
import isInitRegisterBtn from '../../../common/utils/isInitRegisterBtn';
import registerSentry from '../../../common/utils/sentry';

if (document.body) {
    document.body.classList.add('locale-' + LOCALE.toLowerCase());
    document.body.classList.add('system-' + SYSTEM.toLowerCase());
}
declare global {
    interface Window {
        pageConfig: string;
        VERSION: string;
        Sentry: any;
        pageData: any;
        branch: string;
    }
}

const pageConfig = JSON.parse(window.pageConfig || '{}');

const siteHost = getSiteHost();
const initHeader = (userInfo?: IUserInfo) => {
    const options = {
        platform: Platform.MOBILE,
        siteHost,
        lang: LOCALE.toLowerCase(),
        langOptions: getLangSwitchList().map((e) => {
            return {
                text: e.value,
                val: e.key,
            };
        }),
        system: SYSTEM.toLowerCase(),
        isLogin: !!userInfo,
        userInfo: userInfo ? userInfo : undefined,
        headerData: pageConfig.header,
    };
    const headerRenderer = window.HomeHeader.render;
    /**
     * 注意：在应用到的页面html中，确保存在挂载对象，若不存在这手动加上相应标签
     */
    headerRenderer(options as any, document.querySelector('.page-header') as HTMLElement);
};

const initFooter = () => {
    const footerRenderer = window.HomeFooter.render;
    /**
     * 注意：在应用到的页面html中，确保存在挂载对象，若不存在这手动加上相应标签
     */
    footerRenderer(
        {
            platform: Platform.MOBILE,
            siteHost,
            lang: LOCALE.toLowerCase(),
            langOptions: getLangSwitchList().map((e) => {
                return {
                    text: e.value,
                    val: e.key,
                };
            }),
            system: SYSTEM.toLowerCase(),
            footerData: pageConfig.footer,
        },
        document.querySelector('.page-footer') as HTMLElement,
    );
};

const initGDPR = (userId?: string) => {
    gdprCom({
        userId,
        platform: 'm',
        lang: LOCALE.toLowerCase(),
        onAgree: () => {
            loadResource();
        },
    });
};

function showPrompt(userId?: string) {
    const commonConfig = {
        userId,
        stayFunc: initGDPR,
    };
    if (SYSTEM.toLowerCase() === 'en') {
        ipPrompt(
            [
                {
                    ...commonConfig,
                    platform: 'm',
                    countryCode: 'CN',
                    from: 'UMU.COM',
                    to: 'umu.cn',
                    lang: 'cn',
                    mainland_1: '中国',
                    mainland_2: 'mainland China',
                    district_en: 'global',
                    district_cn: '国际',
                    district_jp: 'グローバル',
                },
                {
                    ...commonConfig,
                    platform: 'm',
                    countryCode: 'JP',
                    from: 'UMU.COM',
                    to: 'umu.co',
                    lang: 'jp',
                    mainland_1: '日本',
                    mainland_2: 'Japan',
                    district_en: 'global',
                    district_cn: '国际',
                    district_jp: 'グローバル',
                },
            ],
            commonConfig,
        );
    } else if (SYSTEM.toLowerCase() === 'em') {
        ipPrompt(
            [
                {
                    ...commonConfig,
                    platform: 'm',
                    countryCode: 'CN',
                    from: 'UMU.IO',
                    to: 'umu.cn',
                    lang: 'en',
                    mainland_1: '中国',
                    mainland_2: 'mainland China',
                    district_en: 'European',
                    district_cn: '欧洲',
                    district_jp: 'ヨーロッパ',
                },
                {
                    ...commonConfig,
                    platform: 'm',
                    countryCode: 'JP',
                    from: 'UMU.IO',
                    to: 'umu.co',
                    lang: 'jp',
                    mainland_1: '日本',
                    mainland_2: 'Japan',
                    district_en: 'European',
                    district_cn: '欧洲',
                    district_jp: 'ヨーロッパ',
                },
            ],
            commonConfig,
        );
    } else {
        initGDPR(userId);
    }
}

export default (option?: { cb?: (userInfo: IUserInfo) => void; renderAfter?: () => void }) => {
    const userInfo = getUserInfo();
    option?.renderAfter?.();

    if (userInfo?.umu_id === 0 && !userInfo?.user_name) {
        initHeader();
        isInitRegisterBtn();
    } else {
        initHeader(userInfo);
        isInitRegisterBtn(userInfo);
    }
    initFooter();
    qrCode({
        lang: LOCALE.toLowerCase(),
        system: SYSTEM.toLowerCase(),
    });
    option?.cb?.(userInfo);

    if (SYSTEM.toLowerCase() !== 'cn') {
        showPrompt(userInfo?.umu_id ? String(userInfo.umu_id) : undefined);
    } else {
        registerBesChannels();
    }

    option?.renderAfter?.();
    registerSentry();
};

window.VERSION = VERSION;
window.branch = BRANCH;
